import { LockIcon } from "@xola/icons";
import { capitalize, isArray } from "lodash";
import React from "react";
import { Audit, Purchase, PurchaseItem } from "types";
import { TimelineItem, TimelineItemReason } from "../TimelineItem";

interface PrivacyChangeLineItemProps {
    purchase: Purchase;
    item: PurchaseItem;
    audit: Audit;
}

const privacyConstants = {
    public: "shared",
    private: "private",
};

export const PrivacyChangeLineItem = ({ purchase, item, audit }: PrivacyChangeLineItemProps) => {
    if (!PrivacyChangeLineItem.supportsAudit(purchase, item, audit)) {
        return null;
    }

    const changedPrivacy = getChangedPrivacy(purchase, item, audit);

    if (!changedPrivacy) {
        return null;
    }

    return (
        <TimelineItem title="Privacy Changed" audit={audit} icon={<LockIcon />} color="primary" purchase={purchase}>
            <div className="items-center">
                <TimelineItemReason localize className="pt-1 text-gray-darker">{`${capitalize(
                    privacyConstants[changedPrivacy.old as keyof typeof privacyConstants],
                )} reservation was converted to ${
                    privacyConstants[changedPrivacy.new as keyof typeof privacyConstants]
                } reservation`}</TimelineItemReason>
            </div>
        </TimelineItem>
    );
};

PrivacyChangeLineItem.supportsAudit = (_purchase: Purchase, item: PurchaseItem, audit: Audit) => {
    return (
        isArray(audit.data?.items) &&
        audit?.data?.items?.find((auditItem: any) => auditItem.id === item?.id && auditItem.privacy)
    );
};

const getChangedPrivacy = (_purchase: Purchase, item: PurchaseItem, audit: Audit) => {
    const privacy = audit?.data?.items?.find((auditItem: any) => auditItem.id === item?.id).privacy;
    return privacy ? { old: privacy.old, new: privacy.new } : null;
};
